// Regras puras da tela de Recompensas (admin): sem React, sem rede.
import type { RewardDefinition, RewardRarity } from "../../services/admin";

export const RARITY_TAG: Record<
  RewardRarity,
  { color: string; label: string }
> = {
  common: { color: "default", label: "Comum" },
  uncommon: { color: "green", label: "Incomum" },
  rare: { color: "blue", label: "Raro" },
  legendary: { color: "gold", label: "Lendário" },
};

const plural = (n: number, one: string, many: string): string =>
  `${n} ${n === 1 ? one : many}`;

/** Mesmo texto do backend. */
export function rewardLabel(c: {
  passDays?: number;
  hintCards: number;
  streakProtectors: number;
}): string {
  const parts: string[] = [];
  if (c.passDays && c.passDays > 0)
    parts.push(
      plural(c.passDays, "dia de jogos ilimitados", "dias de jogos ilimitados"),
    );
  if (c.hintCards > 0) parts.push(plural(c.hintCards, "dica", "dicas"));
  if (c.streakProtectors > 0)
    parts.push(plural(c.streakProtectors, "protetor", "protetores"));
  return parts.join(" + ");
}

/** Chance (%) de cada prêmio entre os ativos; 0 para inativos e quando a soma é 0. */
export function effectiveChances(
  defs: Pick<RewardDefinition, "id" | "weight" | "active">[],
): Record<number, number> {
  const total = defs.reduce((sum, d) => (d.active ? sum + d.weight : sum), 0);
  const out: Record<number, number> = {};
  defs.forEach((d) => {
    out[d.id] =
      d.active && total > 0 ? Math.round((d.weight / total) * 1000) / 10 : 0;
  });
  return out;
}

export function formatChance(pct: number): string {
  return `${pct.toFixed(1).replace(".", ",")}%`;
}
